export const buildProvenance = { "commitHash": "53b5c09e435ffafcbbcbd23ff45a3b03722b1d13", "branchName": "refs/heads/release/2024.1", "buildDate": "2024-05-30T08:17:18.759Z", "version": "2024.1.12806" };
